import React, { useEffect } from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import Counter from './Counter';
import './EventPlanned.css';
import heroSideImage from './styles/img/office_friends_working_vertical.jpg';
import imgHoraEs from './styles/img/fecha_8_oct_2026.png';
import imgHoraEn from './styles/img/fecha_8_oct_2026_en.png';
import bgImage from './styles/img/backgroundNV1.png';
import useAxios from 'hooks/useAxios';
import { config } from 'config';
import BitmovinPlayer from 'utils/BitmovinPlayer';
import { useLiveEvents } from './liveUtils';

const EventPlanned = () => {
    const intl = useIntl();
    const { isLive, currentLiveEvent } = useLiveEvents();

    // Inject the external scripts and styles if needed, or rely on local EventPlanned.css
    useEffect(() => {
        window.scrollTo(0, 0);
        // Apply a specific class to body to scope styles if needed, similar to special categories
        document.body.classList.add('theme-event-planned');
        return () => {
            document.body.classList.remove('theme-event-planned');
        };
    }, []);

    const [bitmovinPlayerConfig, setBitmovinPlayerConfig] = React.useState(null);
    const videoId = "6c9066c23c6e4a30bef255ea40327a46";
    const { response, loading, error } = useAxios({
        method: 'get',
        url: `/aos-vod?stream_id=${videoId}&tenant_id=${config.tenant_id}`
    });

    useEffect(() => {
        if (response && response.stream) {
            const stream = response.stream;
            const vodUrl = `${config.cloudfront_hls}/${stream.vod_url}`;
            const configTile = intl.locale.startsWith('en') ? stream.title_en : stream.title;
            const playerConfig = {
                "playerConfig": {
                    "analytics": {
                        "videoId": `TecMilenio-WEB-${videoId}`,
                        "title": `TecMilenio-WEB-${configTile}`,
                        "customData1": `${config.tenant_id}`,
                        "key": "045e1f18-e0b3-4211-83ff-6730d6906c48",
                        "customData2": `TecMilenio-WEB-VOD`,
                        "customData3": `TecMilenio-WEB-${videoId}`
                    },
                    "key": "7d43a709-fd2e-43f5-a35f-1f916c8425bf",
                    "playback": {
                        "autoplay": false,
                        "muted": false,
                        "scaleMode": "zoom"
                    },
                    "remotecontrol": {
                        type: 'googlecast'
                    }
                },
                "playerSource": {
                    "hls": vodUrl,
                    "poster": stream.thumbnail ? `${config.cloudfront_url}/${encodeURI(stream.thumbnail)}` : "https://d2sdk1g41rkzfz.cloudfront.net/none/thumbnails%2Fthumb_placeholder.jpg"
                },
                "viewMode": "fill"
            };
            setBitmovinPlayerConfig(playerConfig);
        }
    }, [response, intl.locale]);

    const home_btn_register_text = intl.formatMessage({ id: 'eventPlannedBtnText' });
    const counter_placeholder_text = intl.formatMessage({ id: 'eventPlannedCounterPlaceholder' });

    return (
        <div className="supercontent home" id="myApp">
            {/* Main Section */}
            <section className="herowelcome">
                <img className="bck" src={bgImage} alt="Background" />
                <div className="homesuperbox">
                    <div className="boxhomesuperbox">
                        <div className="lefthome">
                            <div className="texthome mb-3">
                                <span className='home-overline ff-nyght-italic'>
                                    <FormattedMessage id="eventPlannedHeroOverline" defaultMessage="WELLBEING 360:" />
                                </span>
                                <h1 className='home-title-1 ff-figtree mb-5'>
                                    <FormattedMessage id="eventPlannedHeroTitle1" />
                                    <br/>
                                    <span className='home-title-2 ff-nyght-italic'>
                                        <FormattedMessage id="eventPlannedHeroTitle2" />
                                    </span>
                                </h1>
                                <p className='home-lead'>
                                    <FormattedMessage id="eventPlannedHeroLead1" />
                                </p>
                                <p className='home-lead'>
                                    <FormattedMessage id="eventPlannedHeroLead2" />
                                </p>
                                <p className='home-lead'>
                                    <FormattedMessage id="eventPlannedHeroLead3" />
                                </p>
                            </div>
                            
                            <Link to="/organizaciones-con-proposito/sign-up" className="buttonhome">
                                {home_btn_register_text}
                            </Link> 
                            <Link to="/organizaciones-con-proposito/sign-up" className="buttonhome2">
                                {home_btn_register_text}
                            </Link>
                            
                            <div className="imghour2">
                                <img src={intl.locale.startsWith('en') ? imgHoraEn : imgHoraEs} alt="Hora" />
                            </div>
                            
                            {isLive ? (
                                <div style={{ marginTop: '20px' }}>
                                    <Link to="/organizaciones-con-proposito/live" style={{
                                        display: 'inline-block',
                                        backgroundColor: 'red',
                                        color: 'white',
                                        padding: '10px 20px',
                                        borderRadius: '30px',
                                        fontWeight: 'bold',
                                        fontSize: '18px',
                                        textDecoration: 'none',
                                        animation: 'pulse 2s infinite'
                                    }}>
                                        🔴 <FormattedMessage id="navEventPlannedLive" defaultMessage="Estamos En Vivo" />
                                    </Link>
                                </div>
                            ) : (
                                <Counter targetDateString="Oct 08, 2026 09:30:00" />
                            )}
                        </div>
                        <div className="righthome">
                            <img src={heroSideImage} alt="Wellbeing 360 - Imagen Home" />
                        </div>
                    </div>
                </div>

                <div className="tutorial">
                    <div className="boxtutorial" style={{ textAlign: 'center', marginBottom: '40px' }}>
                        <div className="livetext" style={{ marginBottom: '10px' }}>
                            <FormattedMessage id="eventPlannedVideoTitle" defaultMessage="NO TE LO <span>PIERDAS</span>" values={{ span: (chunks) => <span style={{ color: '#004766', marginLeft: '0.3em' }}>{chunks}</span> }} />
                        </div>
                        <p style={{ color: '#004766', fontSize: '18px', maxWidth: '800px', margin: '0 auto 20px', fontFamily: "'Roboto', sans-serif" }}>
                            <FormattedMessage id="eventPlannedVideoDesc" defaultMessage="Prepárate para una experiencia que te inspirará a transformar tu organización..." />
                        </p>
                        <div style={{ margin: '0 auto', maxWidth: '640px', width: '100%' }}>
                            {bitmovinPlayerConfig ? (
                                <BitmovinPlayer playerConfig={bitmovinPlayerConfig} />
                            ) : (
                                <div style={{ height: '480px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <div className="spinner-border text-light" role="status">
                                        <span className="sr-only">Loading...</span>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                
                {/* TODO: Integrate preguntas component here */}
            </section>
        </div>
    );
};

export default EventPlanned;
